var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPushTrolley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5134_364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.125 14.75C8.16075 14.75 9 15.5892 9 16.625C9 17.6607 8.16075 18.5 7.125 18.5C6.08925 18.5 5.25 17.6607 5.25 16.625C5.25 15.5892 6.08925 14.75 7.125 14.75ZM14.25 16.625C14.25 17.6607 15.0892 18.5 16.125 18.5C17.1607 18.5 18 17.6607 18 16.625C18 15.5892 17.1607 14.75 16.125 14.75C15.0892 14.75 14.25 15.5892 14.25 16.625ZM18 14C18 13.586 17.6647 13.25 17.25 13.25H6.75C5.5095 13.25 4.5 12.2405 4.5 11V4.25C4.5 2.18225 2.81775 0.5 0.75 0.5C0.33525 0.5 0 0.836 0 1.25C0 1.664 0.33525 2 0.75 2C1.9905 2 3 3.0095 3 4.25V11C3 13.0677 4.68225 14.75 6.75 14.75H17.25C17.6647 14.75 18 14.414 18 14ZM14.25 11.75H9.75V2.375C9.75 1.33925 10.5892 0.5 11.625 0.5H12.375C13.4108 0.5 14.25 1.33925 14.25 2.375V11.75ZM12.75 2.375C12.75 2.168 12.5813 2 12.375 2H11.625C11.4187 2 11.25 2.168 11.25 2.375V3.5H12.75V2.375ZM15.75 3.5V11.75C16.9928 11.75 18 10.7428 18 9.5V5.75C18 4.50725 16.9928 3.5 15.75 3.5ZM8.25 11.75V3.5C7.00725 3.5 6 4.50725 6 5.75V9.5C6 10.7428 7.00725 11.75 8.25 11.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushTrolley);
export default __webpack_public_path__ + "static/media/PushTrolley.34886b6533f5540536fc80033dce6e59.svg";
export { ForwardRef as ReactComponent };